import React from 'react'

export default function Notification() {
    return (
        <>
            <section className="s5">
                <div className="s55">
                    <div className="left">
                        <div className="d1">
                            <p>Notification</p>
                            <p className="font-big small">You have new Notifications</p>
                            <hr />
                        </div>
                        <div className="d2">
                            <p className="font-big small">
                                <i className="fa-solid fa-bell hide"></i> Improve your notifications</p>
                            <p className="viewsetting">View Settings</p>
                        </div>
                    </div>
                    <div className="right">
                        <div className="notify">
                            <div className="d1">
                                <div className="img">
                                    <img src="https://pbs.twimg.com/profile_images/1390604720738242563/gz6AcHua_400x400.jpg" alt="Profileimage" />
                                </div>
                                <div className="details">
                                    <p>Welcome to Masai School.</p>
                                    <p>Masai school is starting a full stack web development course. </p>
                                    <div className="comments">
                                        <p className="small">1k Reactions </p>
                                        &nbsp; &nbsp; <i className="fa-solid fa-circle small" style={{fontSize: "6px"}}></i> &nbsp; &nbsp;
                                        <p className="small">1k Comments</p>
                                    </div>
                                </div>
                                <div className="days">
                                    <p className="small align-right">2d</p>
                                    <div className="ellipse">
                                        <p>
                                            <i className="fa-solid fa-ellipsis"></i>
                                        </p>
                                    </div>
                                </div>
                                <hr />
                            </div>
                            <div className="d1">
                                <div className="img">
                                    <img src="https://pbs.twimg.com/profile_images/1390604720738242563/gz6AcHua_400x400.jpg" alt="Profile" />
                                </div>
                                <div className="details">
                                    <p>Welcome to Masai School.</p>
                                    <p>Masai school is starting a full stack web development course. </p>
                                    <div className="comments">
                                        <p className="small">1k Reactions </p>
                                        &nbsp; &nbsp; <i className="fa-solid fa-circle small" style={{fontSize: "6px"}}></i> &nbsp; &nbsp;
                                        <p className="small">1k Comments</p>
                                    </div>
                                </div>
                                <div className="days">
                                    <p className="small align-right">2d</p>
                                    <div className="ellipse">
                                        <p>
                                            <i className="fa-solid fa-ellipsis"></i>
                                        </p>
                                    </div>
                                </div>
                                <hr />
                            </div>
                            <div className="d1">
                                <div className="img">
                                    <img src="https://pbs.twimg.com/profile_images/1390604720738242563/gz6AcHua_400x400.jpg" alt="Profile" />
                                </div>
                                <div className="details">
                                    <p>Welcome to Masai School.</p>
                                    <p>Masai school is starting a full stack web development course. </p>
                                    <div className="comments">
                                        <p className="small">1k Reactions </p>
                                        &nbsp; &nbsp; <i className="fa-solid fa-circle small" style={{fontSize: "6px"}}></i> &nbsp; &nbsp;
                                        <p className="small">1k Comments</p>
                                    </div>
                                </div>
                                <div className="days">
                                    <p className="small align-right">2d</p>
                                    <div className="ellipse">
                                        <p>
                                            <i className="fa-solid fa-ellipsis"></i>
                                        </p>
                                    </div>
                                </div>
                                <hr />
                            </div>
                            <div className="d1">
                                <div className="img">
                                    <img src="https://pbs.twimg.com/profile_images/1390604720738242563/gz6AcHua_400x400.jpg" alt="Profileimage" />
                                </div>
                                <div className="details">
                                    <p>Welcome to Masai School.</p>
                                    <p>Masai school is starting a full stack web development course. </p>
                                    <div className="comments">
                                        <p className="small">1k Reactions </p>
                                        &nbsp; &nbsp; <i className="fa-solid fa-circle small" style={{fontSize: "6px"}}></i> &nbsp; &nbsp;
                                        <p className="small">1k Comments</p>
                                    </div>
                                </div>
                                <div className="days">
                                    <p className="small align-right">2d</p>
                                    <div className="ellipse">
                                        <p>
                                            <i className="fa-solid fa-ellipsis"></i>
                                        </p>
                                    </div>
                                </div>
                                <hr />
                            </div>
                            <div className="d1">
                                <div className="img">
                                    <img src="https://pbs.twimg.com/profile_images/1390604720738242563/gz6AcHua_400x400.jpg" alt="Profile" />
                                </div>
                                <div className="details">
                                    <p>Welcome to Masai School.</p>
                                    <p>Masai school is starting a full stack web development course. </p>
                                    <div className="comments">
                                        <p className="small">1k Reactions </p>
                                        &nbsp; &nbsp; <i className="fa-solid fa-circle small" style={{fontSize: "6px"}}></i> &nbsp; &nbsp;
                                        <p className="small">1k Comments</p>
                                    </div>
                                </div>
                                <div className="days">
                                    <p className="small align-right">2d</p>
                                    <div className="ellipse">
                                        <p>
                                            <i className="fa-solid fa-ellipsis"></i>
                                        </p>
                                    </div>
                                </div>
                                <hr />
                            </div>
                            <div className="d1">
                                <div className="img">
                                    <img src="https://pbs.twimg.com/profile_images/1390604720738242563/gz6AcHua_400x400.jpg" alt="Profile" />
                                </div>
                                <div className="details">
                                    <p>Welcome to Masai School.</p>
                                    <p>Masai school is starting a full stack web development course. </p>
                                    <div className="comments">
                                        <p className="small">1k Reactions </p>
                                        &nbsp; &nbsp; <i className="fa-solid fa-circle small" style={{fontSize: "6px"}}></i> &nbsp; &nbsp;
                                        <p className="small">1k Comments</p>
                                    </div>
                                </div>
                                <div className="days">
                                    <p className="small align-right">2d</p>
                                    <div className="ellipse">
                                        <p>
                                            <i className="fa-solid fa-ellipsis"></i>
                                        </p>
                                    </div>
                                </div>
                                <hr />
                            </div>
                            <div className="d1">
                                <div className="img">
                                    <img src="https://pbs.twimg.com/profile_images/1390604720738242563/gz6AcHua_400x400.jpg" alt="Profileimage" />
                                </div>
                                <div className="details">
                                    <p>Welcome to Masai School.</p>
                                    <p>Masai school is starting a full stack web development course. </p>
                                    <div className="comments">
                                        <p className="small">1k Reactions </p>
                                        &nbsp; &nbsp; <i className="fa-solid fa-circle small" style={{fontSize: "6px"}}></i> &nbsp; &nbsp;
                                        <p className="small">1k Comments</p>
                                    </div>
                                </div>
                                <div className="days">
                                    <p className="small align-right">2d</p>
                                    <div className="ellipse">
                                        <p>
                                            <i className="fa-solid fa-ellipsis"></i>
                                        </p>
                                    </div>
                                </div>
                                <hr />
                            </div>
                            <div className="d1">
                                <div className="img">
                                    <img src="https://pbs.twimg.com/profile_images/1390604720738242563/gz6AcHua_400x400.jpg" alt="Profileimage" />
                                </div>
                                <div className="details">
                                    <p>Welcome to Masai School.</p>
                                    <p>Masai school is starting a full stack web development course. </p>
                                    <div className="comments">
                                        <p className="small">1k Reactions </p>
                                        &nbsp; &nbsp; <i className="fa-solid fa-circle small" style={{fontSize: "6px"}}></i> &nbsp; &nbsp;
                                        <p className="small">1k Comments</p>
                                    </div>
                                </div>
                                <div className="days">
                                    <p className="small align-right">2d</p>
                                    <div className="ellipse">
                                        <p>
                                            <i className="fa-solid fa-ellipsis"></i>
                                        </p>
                                    </div>
                                </div>
                                <hr />
                            </div>
                            <div className="d1">
                                <div className="img">
                                    <img src="https://pbs.twimg.com/profile_images/1390604720738242563/gz6AcHua_400x400.jpg" alt="Profileimage" />
                                </div>
                                <div className="details">
                                    <p>Welcome to Masai School.</p>
                                    <p>Masai school is starting a full stack web development course. </p>
                                    <div className="comments">
                                        <p className="small">1k Reactions </p>
                                        &nbsp; &nbsp; <i className="fa-solid fa-circle small" style={{fontSize: "6px"}}></i> &nbsp; &nbsp;
                                        <p className="small">1k Comments</p>
                                    </div>
                                </div>
                                <div className="days">
                                    <p className="small align-right">2d</p>
                                    <div className="ellipse">
                                        <p>
                                            <i className="fa-solid fa-ellipsis"></i>
                                        </p>
                                    </div>
                                </div>
                                <hr />
                            </div>
                        </div>
                        <div className="right2 mu-4">
                            <footer>
                                <div className="foot">
                                    <a href="/footer">About</a> &nbsp; &nbsp;
                                    <a href="/footer">Accessibility</a> &nbsp; &nbsp;
                                    <a href="/footer">Help Center</a> &nbsp;
                                    <a href="/footer">Privacy and terms <i className="fa-solid fa-chevron-down"></i></a> &nbsp; &nbsp;
                                    <a href="/footer">Ad Choices</a> &nbsp;
                                    <a href="/footer">Advertising</a> &nbsp;
                                    <a href="/footer">Business Services <i className="fa-solid fa-chevron-down"></i></a> &nbsp; &nbsp;
                                    <a href="/footer">Get the Linkedin app</a> &nbsp; &nbsp;
                                    <a href="/footer">More</a> &nbsp; &nbsp;
                                </div>
                                <h5>Linked <i className="fa-brands fa-linkedin"></i> LinkedIn Corporation &#x24B8; 2022</h5>
                            </footer>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
